<template>
  <component
    :is="tagCompute"
    :to="to"
    :href="link"
    :target="target"
    class="breadcrumb-container inline-block mt-16"
    @click="clickEmitter"
  >
    <div v-if="header" class="flex flex-row items-center breadcrumb">
      <ArrowHead style="transform: scaleX(-1)" class="mr-8" />
      <span>{{ text }}</span>
    </div>
  </component>
</template>

<script lang="ts">
import ArrowHead from '../../icons/ArrowHead.vue';

export default {
  name: 'Breadcrumb',
  components: { ArrowHead },
  props: {
    header: {
      default: '',
      type: String,
    },
    to: {
      default: '',
      type: [String, Object],
    },
    href: {
      default: '',
      type: String,
    },
    target: {
      default: '',
      type: String,
    },
    anchorLink: {
      default: false,
      type: Boolean,
    },
    isButton: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    tagCompute() {
      const returnPath = (this.$route as { query?: { returnPath?: string } } | undefined)?.query?.returnPath;
      if (returnPath) return 'a';
      if (this.to) return 'router-link';
      if (this.anchorLink) return 'a';
      if (this.isButton) return 'button';
      return 'div';
    },
    link() {
      const returnPath = (this.$route as { query?: { returnPath?: string } } | undefined)?.query?.returnPath;
      if (returnPath) {
        return returnPath;
      }
      return this.href || null;
    },
    text() {
      const returnPath = (this.$route as { query?: { returnPath?: string } } | undefined)?.query?.returnPath;
      if (returnPath) {
        return 'Back';
      }
      return this.header;
    },
  },
  methods: {
    clickEmitter(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb-container {
  position: relative;
  outline: none;
  cursor: pointer;
  &:focus-visible {
    // simulates hover effect with keyboard focus
    .breadcrumb,
    .breadcrumb svg path {
      color: theme('colors.brand.contrast');
      fill: theme('colors.brand.contrast');
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border: 2px dotted theme('colors.brand.contrast');
      margin: -4px;
      border-radius: theme('borderRadius.lg');
    }
  }
}

.breadcrumb {
  color: theme('colors.primary.DEFAULT');
  &:hover,
  &:hover svg path {
    color: theme('colors.brand.contrast');
    fill: theme('colors.brand.contrast');
  }
}
</style>
